import React from 'react';

import Section from '../../layout/Section';
import Button from '../../atoms/Button';
import SquareGenerator from '../../molecules/SquareGenerator';
import TilesSlider from './TilesSlider';

import { SLink, SHeader } from './styles';

const SectionInlineTiles = ({
    config,
    background,
}) => {
    const {
        title,
        id,
        cta,
        tileList,
        squares,
        forwardedRef,
    } = config;

    const {
        text: ctaText,
        link: ctaLink,
        type: ctaType,
    } = cta;

    return (
        <Section
            background={ background }
            forwardedRef={ forwardedRef }
            id={ id }
        >
            <SHeader>
                { title }
            </SHeader>
            {
                tileList && 
                    <TilesSlider
                        sliderData={ tileList }
                    />
            }
            <SLink href={ ctaLink } target="_blank">
                <Button type={ ctaType } black>
                    { ctaText }
                </Button>
            </SLink>
            {
                !!squares && <SquareGenerator squares={ squares }/>
            }
        </Section>
    );
};

export default SectionInlineTiles;
